import { UPDATE_UTILITIES } from "@actions/utilities/"

export const updateUtilities = (key, value) => dispatch => dispatch({ type: UPDATE_UTILITIES, key, value })
